module.exports = __webpack_public_path__ + "media/images/down-arrow-9df83d8e8ba0f0a09d8bc2590c110ead.png";